import React, { useCallback } from "react";
import AsyncSelect from "react-select/async";
import debounce from "lodash.debounce";
import { getAddressDetailGmailAPI, getAddressListGmailAPI } from "../../../api/master/indes";

const MyGmailAddressSearch = ({ watch, setValue, errors,trigger }) => {
  // ------------------------------------
  // FETCH CITY LIST FROM BACKEND
  // ------------------------------------
  const loadOptions = async (inputValue) => {
    if (!inputValue || inputValue.length < 2) return [];

    try {
      const body = inputValue;

      setValue("selectedAddress", "");
      const res = await getAddressListGmailAPI(body);
      console.log("res", res);

      return res.data;
    } catch (err) {
      console.error("City search error:", err);
      return [];
    }
  };

  // ------------------------------------
  // DEBOUNCE THE SEARCH CALL
  // ------------------------------------
  const debouncedLoadOptions = useCallback(
    debounce((inputValue, callback) => {
      loadOptions(inputValue).then(callback);
    }, 500),
    [],
  );

  // ------------------------------------
  // HANDLE CITY SELECTION
  // ------------------------------------
  const handleSelect = async (selected) => {
    const cityId = selected?.value || null;

    setValue("selectedAddress", selected);
console.log("selected",selected);

    // send selected city to backend
     const res = await getAddressDetailGmailAPI(selected?.value);
     console.log("selected address details",res?.data?.zipDetails)
     console.log("selected address zip details",res?.data?.placeDetails)
     const components = res?.data?.placeDetails?.address_components;
     setValue("map_link",res?.data?.placeDetails?.url)
   
const getByType = (components, type) =>
  components.find((c) => c.types.includes(type))?.long_name || null;
  console.log("--->",selected)

     setValue("pincode",getByType(components, "postal_code"),)
     setValue("address",selected?.label||"")
     setValue("latitude",res?.data?.placeDetails?.geometry?.location?.lat)
     setValue("longitude",res?.data?.placeDetails?.geometry?.location?.lng)


       trigger([
            "selectedAddress",
            // "name",
            // "lab_type",
            "pincode",
            "state",
            "city",
            "address",
            "map_link",
            // "person_name",
            // "contact_number",
            // "mobile",
            // "email",
            // "alt_contact_number",
            "latitude",
            "longitude",
          ]).then(() => {
            console.log("Validation triggered and errors cleared");
          });

     
  };

  const selectedAddressId = watch("selectedAddress");

  return (
    <div className="form-group">
      <div className="form-control-wrap " style={{marginTop:"35px"}}>
        <AsyncSelect
          cacheOptions
          loadOptions={debouncedLoadOptions}
          defaultOptions={false}
          placeholder="Search address..."
          onChange={handleSelect}
          value={selectedAddressId?.value ? watch("selectedAddress") : null}
          // styles={{
          //   control: (base) => ({
          //     ...base,
          //     color: "#999",
          //     height: "50px",
          //     outline: "none",
          //     lineHeight: "46px",
          //     paddingLeft: "20px",
          //     paddingRight: "40px",
          //     fontSize: "16px",
          //     paddingTop: "0px",
          //     paddingBottom: "0px",
          //     borderRadius: "4px",
          //     border: "2px solid #eee",
          //   }),
          // }}
          isClearable
          noOptionsMessage={() => "Please search address"}
        />

        {errors?.selectedAddress && <small className="text-danger">{errors.selectedAddress.message}</small>}
      </div>
    </div>
  );
};

export default MyGmailAddressSearch;
